import { LookupType } from '../lookup/lookup-type';
import { Attachment } from '../attachment/attachment';
import { FacilityContact } from '../facility/facility-contact';
import { Address } from '../address/address';
import { ApplicationBase, ApplicationSummaryBase } from './application-base';

export interface MembershipApplication extends ApplicationBase {
  birthDate?: string;
  genderId?: number;
  gender?: LookupType;
  preferredLanguageId?: number;
  preferredLanguage?: LookupType;
  email?: string;
  employerFacilityContactId?: number;
  employerFacilityContact?: FacilityContact;
  mailingAddressId?: string;
  mailingAddress?: Address;
  phoneNumberCountryCode?: string;
  phoneNumber?: string;
  secondaryPhoneNumberCountryCode?: string;
  secondaryPhoneNumber?: string;
  paymentInformation?: string;
  billingAddressIsSameAsMailingAddress?: boolean;
  billingAddressId?: string;
  billingAddress?: Address;
  applicationType?: ApplicationTypeId;
  patTaskStatus?: LookupType;
  patTaskStatusId?: number;
  disabled?: boolean;
}

export interface MembershipApplicationSummary extends ApplicationSummaryBase {
  patStatusId: number;
  patStatus: string;
  employerFacilityVerified: boolean;
}

export interface MembershipApplicationTask {
  id?: number;
  applicationTaskId?: number;
  applicationTask?: ApplicationTask;
  applicationTaskStatusId?: number;
  applicationTaskStatus?: LookupType;
  completed?: boolean;
  uploads?: Upload[];
}

export interface ApplicationTask {
  id?: number;
  applicationTypeId?: number;
  applicationType?: LookupType;
  applicationTaskGroup?: number;
  name?: string;
  description?: string | null;
  taskStatuses?: LookupType[] | null;
  uploads?: Attachment[] | null;
}

export interface Upload {
  id?: number;
  membershipApplicationTaskId?: number;
  attachmentId?: string;
  attachment: Attachment;
}

export enum ApplicationTypeId {
  NewMembership = 1,
  Reapplication = 2,
  Reinstatement = 3,
}

export enum ApplicationTaskId {
  ProofOfAge = 1,
  ReferenceLetter = 2,
  RulesOfGolf = 3,
  OnboardingModule = 4,
  ProofOfEducation = 5,
  PlayerPass = 6,
  PAT = 7,
  BeneficiaryForm = 8,
  Sin = 9,
  RespectInSports = 10,
  CompleteSafeSport = 11,
  PoliceCheck = 12,
  PaymentOfDues = 13,
}

export enum ReapplicationTaskId {
  ReapplicationFee = 14,
  ConfirmContact = 15,
  ConfirmEmployment = 16,
  ReferenceLetter = 17,
  ProofOfAge = 18,
  RulesOfGolf = 19,
  OnboardingModule = 20,
  ProofOfEducation = 21,
  PlayerPass = 22,
  PAT = 23,
  BeneficiaryForm = 24,
  Sin = 25,
  RespectInSports = 26,
  CompleteSafeSport = 27,
  PoliceCheck = 28,
  PaymentOfDues = 29,
}

export enum ReinstatementTaskId {
  RespectInSports = 30,
  CompleteSafeSport = 31,
  JobDescription = 32,
  LetterOfEmployment = 33,
  PoliceCheck = 34,
  PaymentOfDues = 35,
}

export enum ApplicationStatusTypeId {
  Pending = 1,
  Expired = 2,
  Approved = 3,
  Denied = 4,
}

export enum ApplicationTaskStatusTypeId {
  Submitted = 1,
  Verified = 2,
  NotAccepted = 3,
  Pending = 4,
  Passed = 5,
  Failed = 6,
  Exempt = 7,
}

export enum PatTaskStatusTypeId {
  Pending = 4,
  Passed = 5,
  Failed = 6,
  Exempt = 7,
}
